
import { useEffect, useRef, useState } from "react";
import { useFontSize } from "./contexts/AccessibilityContext";
import settingsclicked from '../assets/settings-clicked.svg';
import settings from '../assets/settings.svg';

function AccessibilityAccordion() {



  const [active, setActive] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const { fontSize, setFontSize } = useFontSize();

  useEffect(() => {
    if (!active) return;
    const closeOnEscapeOrOutside = (event: KeyboardEvent | MouseEvent) => {
      if (event instanceof KeyboardEvent && event.key === "Escape") {
        setActive(false);
        triggerRef.current?.focus();
      } else if (event instanceof MouseEvent && !containerRef.current?.contains(event.target as Node)) {
        setActive(false);
      }
    };
    document.addEventListener("keydown", closeOnEscapeOrOutside);
    document.addEventListener("mousedown", closeOnEscapeOrOutside);
    return () => {
      document.removeEventListener("keydown", closeOnEscapeOrOutside);
      document.removeEventListener("mousedown", closeOnEscapeOrOutside);
    };
  }, [active]);

  const handleFontSizeChange = (event:any) => {
    setFontSize(event.target.value);
    const root = document.documentElement;
    console.log(event.target.value);
    switch (event.target.value) {
      case 'sm':
        root.style.fontSize = '16px';
        break;
      case 'md':
        root.style.fontSize = '17px';
        break;
      case 'lg':
        root.style.fontSize = '18px';
        break;
      default:
        root.style.fontSize = '50px';
        break;
    }
  };

  const resetSettings = () => {
    const root = document.documentElement;
    root.style.fontSize = '16px';
    root.style.setProperty('--bg-color', 'white');
    root.style.setProperty('--text-color', 'black');
    document.body.classList.remove('theme-applied');
    setFontSize('sm');
  };

  const handleThemeChange = (textColor: string, bgColor: string) => {
    const root = document.documentElement;
    root.style.setProperty('--bg-color', bgColor);
    root.style.setProperty('--text-color', textColor);
    document.body.classList.add('theme-applied');
  };

  return (
    <div className="relative" ref={containerRef}>
      <button
        ref={triggerRef}
        onClick={() => setActive(!active)}
        className="p-2 rounded-md bg-gray-100 hover:bg-gray-200 transition"
        aria-label="Accessibility settings"
        aria-expanded={active}
        aria-controls="accessibility-settings-panel"
      >
        <img src={active ? settingsclicked : settings} alt="" aria-hidden="true" className="w-6 h-6" />
      </button>

      {active && (
        <div
          id="accessibility-settings-panel"
          className="absolute right-0 mt-2 w-64 bg-white shadow-lg border rounded-lg p-4 z-50"
          role="dialog"
          aria-modal="false"
          aria-labelledby="accessibility-settings-title"
        >
          <div className="card-body-half">
            <h2 id="accessibility-settings-title" className="accessibility-settings-title">Accessibility settings</h2>
            <h3>Font size</h3>
            <div role="list" className="button-list justify-content-around">
              <div role="listitem">
                <button
                  aria-label="Small font"
                  type="button"
                  value="sm"
                  className="font-button btn"
                  aria-pressed={fontSize === "sm"}
                  onClick={handleFontSizeChange}
                >
                  A
                </button>
              </div>
              <div role="listitem" className="font-button-li">
                <button
                  aria-label="Medium font"
                  type="button"
                  value='md'
                  className="font-button btn"
                  aria-pressed={fontSize === "md"}
                  onClick={handleFontSizeChange}
                >
                  A+
                </button>
              </div>
              <div role="listitem" className="font-button-li">
                <button
                  aria-label="Large font"
                  type="button"
                  value='lg'
                  className="font-button btn"
                  aria-pressed={fontSize === "lg"}
                  onClick={handleFontSizeChange}
                >
                  A++
                </button>
              </div>
            </div>
          </div>
          <div className="card-body-half">
            <h3 className="card-p">Color themes</h3>
            <div role="list">
              {[
                { label: "Green & white", colors: ["rgb(23, 139, 139)", "white"] },
                { label: "Red & white", colors: ["rgb(142, 3, 0)", "white"] },
                { label: "Black & white", colors: ["black", "white"] },
                { label: "Yellow & black", colors: ["rgb(255, 255, 1)", "black"] },
                { label: "Yellow & blue", colors: ["rgb(255, 255, 1)", "rgb(7, 7, 238)"] },
                { label: "White & black", colors: ["white", "black"] }
              ].map((theme, index) => (
                <div role="listitem" key={index}>
                <button
                  className="theme-buttons"
                    aria-label={theme.label}
                    onClick={() => handleThemeChange(theme.colors[0], theme.colors[1])}
                >
                    <div className="theme-button-border" style={{ display: "flex" }}>
                      {theme.colors.map((color, idx) => (
                    <div
                          key={idx}
                      className="theme-colors"
                          style={{ background: color, width: "20px", height: "20px" }}
                    ></div>
                      ))}
                  </div>
                </button>
              </div>
              ))}
                  </div>
              </div>



          <div className="flex justify-between pt-4">
            <button onClick={resetSettings} className="text-sm px-3 py-1 border rounded bg-gray-100 hover:bg-gray-200">
              Reset All
            </button>
            <button onClick={() => setActive(false)} className="text-sm px-3 py-1 border rounded bg-gray-100 hover:bg-gray-200">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AccessibilityAccordion;
